export default __webpack_public_path__ + "static/media/lp-sec07_benefits03.80ae4fd9.png";